import { useEffect, useMemo } from "react";
import { useLaunchParams } from "@telegram-apps/sdk-react";
import { activatePromo } from "@/api/user";
import { useAuth } from "@/store/authStore";
import { useSubscriptionStore } from "@/store/useSubscriptionStore";
import { useWelcomeInfo } from "@/store/welcomeInfo";

function getPromoCode(startParam?: string | null) {
  if (!startParam?.startsWith("promo_")) return null;
  return startParam;
}

export function usePromoActivation() {
  const { initData } = useAuth();
  const setIsSubscriptionActive = useSubscriptionStore(
    (s) => s.setIsSubscriptionActive
  );
  const setPromoGiftDays = useWelcomeInfo((s) => s.setPromoGiftDays);
  const launchParams = useLaunchParams(true);
  const promoCode = useMemo(
    () => getPromoCode(launchParams.tgWebAppStartParam),
    [launchParams.tgWebAppStartParam]
  );

  useEffect(() => {
    if (!initData || !promoCode) return;

    const run = async () => {
      try {
        const response = await activatePromo(promoCode);

        if (!response.applied || response.days <= 0) return;

        setIsSubscriptionActive(true);
        setPromoGiftDays(response.days);
      } catch (error) {
        console.error("Failed to activate promo", error);
      }
    };

    run();
  }, [initData, promoCode, setIsSubscriptionActive, setPromoGiftDays]);
}
